import * as Yup from 'yup';
import { get, pick } from 'lodash';
import { anyValue } from '../../../helpers/objects';

import { SENSOR_SOURCING_OPTIONS } from '../../../helpers/sensors';

const EquipmentSourceTypes = ['Equipment', 'Rule'];
const MultiSensorSourceTypes = ['Equipment', 'General', 'System'];

const ModifyRuleSensorModalSchema = Yup.object().shape({
    equipmentTypeId: Yup.string()
        .nullable()
        .when('sourceType', (sourceType, schema) => {
            if (EquipmentSourceTypes.includes(sourceType)) {
                return schema.required();
            }
        }),
    measurement: Yup.string()
        .nullable()
        .when('sourceType', (sourceType, schema) => {
            if (sourceType === 'Weather') {
                return schema.required();
            }
        }),
    multiSensorOption: Yup.string()
        .nullable()
        .when('sourceType', (sourceType, schema) => {
            if (MultiSensorSourceTypes.includes(sourceType)) {
                return schema.required();
            }
        }),
    ruleId: Yup.string()
        .nullable()
        .when('sourceType', (sourceType, schema) => {
            if (sourceType === 'Rule') {
                return schema.required();
            }
        }),
    sensorAggregateDuration: Yup.number()
        .nullable()
        .when('sensorAggregateType', (sensorAggregateType, schema) => {
            if (sensorAggregateType === 'None') {
                return schema;
            }
            return schema.required();
        }),
    sensorSourcing: Yup.object()
        /**
         * Gets the possible options associated with the combined values of
         * `sourceType` and `ruleTarget` and ensures that at least one of the
         * options is flagged as TRUE.
         */
        .when('sourceType', (sourceType, schema) => {
            const { meta: { ruleTarget } = {} } = schema.describe();
            const sensorSourcingOptions = get(
                SENSOR_SOURCING_OPTIONS,
                `${sourceType}.${ruleTarget}`,
                []
            );
            if (!sensorSourcingOptions.length) {
                return;
            }
            return schema.test(
                'has-selected',
                'At least one option must be selected.',
                value => anyValue(pick(value, sensorSourcingOptions), true)
            );
        }),
    sensorTypeId: Yup.string()
        .nullable()
        .when('sourceType', (sourceType, schema) => {
            if (sourceType !== 'Weather') {
                return schema.required();
            }
        }),
    sourceType:   Yup.string().nullable().required(),
    systemTypeId: Yup.string()
        .nullable()
        .when('sourceType', (sourceType, schema) => {
            if (sourceType === 'System') {
                return schema.required();
            }
        })
});

export default ModifyRuleSensorModalSchema;
